import { RouteRecordRaw } from "vue-router"
import { routePaths } from "../routePaths"

const governRoutes: RouteRecordRaw[] = [
  {
    path: "/govern",
    name: "govern",
    component: () => import("@/layout/AbstractRouteView.vue"),
    meta: {
      isProtected: true
    },
    children: [
      {
        path: routePaths.govern.policy.path,
        name: routePaths.govern.policy.pathName,
        component: () => import("@/modules/govern/policies/pages/Policies.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "sideMenu.govern",
              translationKey: "sideMenu.govern",
              routeName: ""
            },
            {
              title: "sideMenu.myPolicies",
              translationKey: "sideMenu.myPolicies",
              routeName: ""
            }
          ]
        }
      },
      {
        path: routePaths.govern.contractAgreements.path,
        name: routePaths.govern.contractAgreements.pathName,
        component: () => import("@/modules/govern/agreements/pages/ContractAgreements.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "sideMenu.govern",
              translationKey: "sideMenu.govern",
              routeName: ""
            },
            {
              title: "sideMenu.contractAgreements",
              translationKey: "sideMenu.contractAgreements",
              routeName: ""
            }
          ]
        }
      },
      {
        path: routePaths.govern.connectors.path,
        name: routePaths.govern.connectors.pathName,
        component: () => import("@/modules/govern/connectors/pages/Connectors.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "sideMenu.govern",
              translationKey: "sideMenu.govern",
              routeName: ""
            },
            {
              title: "sideMenu.connectors",
              translationKey: "sideMenu.connectors",
              routeName: ""
            }
          ]
        }
      },
      {
        path: routePaths.govern.contractDefinitions.path,
        name: routePaths.govern.contractDefinitions.pathName,
        component: () =>
          import("@/modules/govern/contractDefinitions/pages/ContractDefinition.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "sideMenu.govern",
              translationKey: "sideMenu.govern",
              routeName: ""
            },
            {
              title: "sideMenu.contractDefinitions",
              translationKey: "sideMenu.contractDefinitions",
              routeName: ""
            }
          ]
        }
      }
    ]
  }
]

export default governRoutes
